import React from 'react';
import clsx from 'clsx';

import {ArrowLink} from '@/modules/finkn/components/arrow-link';
import {ContentBlockHeading} from '@/modules/foundation/components/content-block-heading';
import type {KeyedArray} from '@/modules/foundation/shared/types';

import {ContentBlockContainer, type ContentBlockContainerProps} from '../block-container';

export type LinkListItem = {
	href: string;
	title: string;
	targetBlank?: boolean;
};

interface Props extends ContentBlockContainerProps {
	links?: KeyedArray<LinkListItem>;
	heading?: string;
	anchorHeadings?: boolean;
	insideToc?: boolean;
}

export const LinkListSelection = ({links, options, heading, anchorHeadings, insideToc}: Props) => {
	return (
		<ContentBlockContainer
			options={options}
			width={options?.fullWidth ? 'screen' : 'text'}
			insideToc={insideToc}
		>
			<ContentBlockHeading heading={heading} anchorHeading={anchorHeadings} />
			<ul className={clsx('grid')}>
				{links?.map((link) => (
					<li
						key={link._key}
						className={clsx('border-b', 'border-grey-border', 'first:border-t')}
					>
						<ArrowLink
							href={link.href}
							className={clsx('text-base', 'font-normal', 'py-4')}
							targetBlank={link.targetBlank}
						>
							{link.title}
						</ArrowLink>
					</li>
				))}
			</ul>
		</ContentBlockContainer>
	);
};
